<div id="myModal" class="modal">
    <div class="modal-content">
        <div id="smartText" class="text-container">
            <div id="translateElement" #translateElement>Here we have some text</div>
        </div>

        <div class="button-container">
            <button #ok class="ok-button" (click)="closeOk()">OK</button>
            <button #cancel class="close-button" (click)="close()">Close</button>
        </div>
    </div>
</div>